import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell, Trash2, AlertTriangle, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";
import DashboardLayout from "@/components/DashboardLayout";

function timeAgo(iso) {
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return new Date(iso).toLocaleString();
}

export default function Notifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/notifications").then((r) => setItems(r.data.items)).finally(() => setLoading(false));
  useEffect(() => { load(); api.post("/notifications/read-all"); }, []);

  const del = async (id) => { await api.delete(`/notifications/${id}`); load(); };
  const clearAll = async () => { if (!window.confirm("Clear all notifications?")) return; await api.post("/notifications/clear"); toast.success("Cleared"); load(); };

  return (
    <DashboardLayout title="Notifications"
      actions={items.length > 0 && <button onClick={clearAll} className="btn-ghost px-4 py-2.5 rounded-full text-sm flex items-center gap-2" data-testid="notif-page-clear"><Trash2 size={15} /> Clear all</button>}>
      {loading ? <p className="text-[#8B9BB4]">Loading…</p> :
        items.length === 0 ? (
          <div className="iw-card p-12 text-center">
            <Bell className="text-[#D4AF37] mx-auto mb-3" size={32} />
            <h3 className="font-display text-2xl font-bold">No notifications</h3>
            <p className="text-[#8B9BB4] mt-2">Alerts like failing CRM webhooks will appear here.</p>
          </div>
        ) : (
          <div className="space-y-3 fade-up max-w-3xl" data-testid="notif-page-list">
            {items.map((n) => {
              const failing = n.type === "webhook_failing";
              const Icon = failing ? AlertTriangle : CheckCircle2;
              return (
                <div key={n.id} className="iw-card p-5 flex items-start gap-4" data-testid={`notif-item-${n.id}`}>
                  <div className={`h-9 w-9 rounded-lg flex items-center justify-center shrink-0 ${failing ? "bg-red-400/10" : "bg-[#142B5A]"}`}>
                    <Icon size={17} className={failing ? "text-red-400" : "text-[#D4AF37]"} />
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="text-sm text-[#F6F1E4]">{n.message}</p>
                    <div className="flex items-center gap-2 mt-1">
                      <span className="overline text-[10px]">{n.type.replace(/_/g, " ")}</span>
                      <span className="text-xs text-[#8B9BB4]">· {timeAgo(n.created_at)}</span>
                    </div>
                  </div>
                  <button onClick={() => del(n.id)} className="text-[#8B9BB4] hover:text-red-400 transition-colors shrink-0" data-testid={`notif-del-${n.id}`}><Trash2 size={15} /></button>
                </div>
              );
            })}
          </div>
        )}
    </DashboardLayout>
  );
}
